import React, { Fragment } from 'react';
import * as R from 'ramda';
import { Form, Select, Icon, Divider, Modal } from 'antd';
import { object, func, string, array, bool } from 'prop-types';


import { SvgIcon } from '../svg-icon';
import { Popconfirm } from '../popovers';
import Attachments from '../attachments/';
import { AssignButton } from '../ui-helpers';
import { ReactQuillWrapped } from '../react-quill';
import { AddNewContactModal } from '../../modals/add-new-contact';
import StyledSelect from '../../components/ui-helpers/styled-select';
import {
  truncate,
  getAvatarUrl,
  filterOption,
  getCurrentUserId,
  disabledFutureDays,
  sortDataByAlphabet,
  checkUnassignedSalesWithoutTasks,
} from '../../utils';

import {
  DetailKey,
  DetailValue,
} from '../requests-list-item/styled-components';

import {
  Title,
  InputS,
  SelectS,
  Controls,
  DividerS,
  FormItemS,
  OptionPart,
  DetailItem,
  ButtonSave,
  DatePickerS,
  OptionWrapper,
  FieldWrapper,
  UserImageWrap,
  ButtonWrapper,
  SelectDropdown,
  AddContactButton,
} from './styles';

import { OptionPopover } from './project-info-popover';

const { confirm } = Modal;
const { Option } = Select;

const RequestForm = (props) => {
  const {
    form: { getFieldDecorator, setFieldsValue },
    setSelectedRequestSource,
    requestStatusesOptions,
    selectedRequestStatus,
    selectedRequestSource,
    selectedRequestLabels,
    requestSourcesOptions,
    onConfirmStatusChange,
    onCancelStatusChange,
    isStatusPopUpVisible,
    requestLabelsOptions,
    handleContactSearch,
    setSelectedContacts,
    setSelectedProject,
    onToggleContactForm,
    isFetchingContacts,
    handleChangeLabels,
    handleChangeStatus,
    isContactFormOpen,
    selectedContacts,
    selectedProject,
    searchedContacts,
    setSelectedUsers,
    withAddContact,
    selectedUsers,
    onSubmitForm,
    description,
    isAttachmentsLoading,
    isFetchingProjects,
    isLoading,
    setContactsData,
    subject,
    isEdit,
    projects,
    users,
    title,
    date,
    requestTasks,
    tasks,
  } = props;

  return (
    <Fragment>
      <Title>{title}</Title>
      {isContactFormOpen && withAddContact
        && <AddNewContactModal isSubForm handleHideForm={onToggleContactForm} />}
      <Form onSubmit={onSubmitForm}>
        {!isContactFormOpen &&
          <Fragment>
            <FormItemS
              colon={false}
              label="Contact"
            >
              <div onMouseDown={(e) => {
                e.preventDefault();
                return false;
              }}
              >
                {getFieldDecorator('contacts', {
                  initialValue: selectedContacts,
                  rules: [{
                    required: true, message: 'Please choose contact',
                  }],
                })(<SelectS
                  autoFocus
                  showSearch
                  allowClear
                  size="large"
                  labelInValue={!isEdit}
                  mode="multiple"
                  showArrow={false}
                  filterOption={false}
                  onBlur={setContactsData}
                  loading={isFetchingContacts}
                  onSearch={handleContactSearch}
                  onChange={setSelectedContacts}
                  defaultActiveFirstOption={false}
                  placeholder="Search contact by full name or email..."
                  notFoundContent={isFetchingContacts ? null : 'Not Found. You may create new Contact...'}
                  getPopupContainer={triggerNode => triggerNode.parentNode}
                  dropdownRender={(menu) => {
                    if (!isFetchingContacts && menu.props.inputValue.length > 1) {
                      return (
                        <SelectDropdown>
                          {menu}
                        </SelectDropdown>
                      );
                    }
                    return (<SelectDropdown />);
                  }}
                >
                  {searchedContacts.map(item => (
                    <Option key={item._id} value={item._id}>
                      <div>
                        <OptionPart>
                          <Icon type="user" /> {item.fullName}
                        </OptionPart>
                        {!R.isNil(item.emails) && !R.isEmpty(item.emails) &&
                        <OptionPart>
                          <Divider type="vertical" />
                          <Icon type="mail" /> {item.emails[0]}
                        </OptionPart>
                        }
                      </div>
                    </Option>
                  ))}
                </SelectS>)}
              </div>
            </FormItemS>
            {withAddContact &&
              <AddContactButton
                type="primary"
                key="addContact"
                onClick={onToggleContactForm}
              >
                <SvgIcon type="plus" />&nbsp;Add Contact
              </AddContactButton>
            }
          </Fragment>
        }
        <DividerS />
        <FormItemS
          colon={false}
          label="Project"
        >
          <SelectS
            showSearch
            size="large"
            allowClear
            value={selectedProject}
            placeholder="Choose project..."
            defaultActiveFirstOption={false}
            getPopupContainer={triggerNode => triggerNode.parentNode}
            onChange={value => setSelectedProject(value)}
            filterOption={(input, option) =>
              option.props.children.props.children[0]
                .toLowerCase().indexOf(input.toLowerCase().trim()) >= 0
            }
            loading={isFetchingProjects}
            disabled={isFetchingProjects}
          >
            {sortDataByAlphabet('name', projects).map(item => (
              <Option
                key={item._id}
                value={item._id}
              >
                <OptionWrapper>
                  {truncate(item.name)}

                  <OptionPopover project={item}>
                    <Icon
                      type="info-circle"
                      style={{ paddingLeft: '10px', cursor: 'pointer' }}
                    />
                  </OptionPopover>
                </OptionWrapper>
              </Option>
            ))}
          </SelectS>
        </FormItemS>
        <DividerS />
        <FormItemS
          colon={false}
          label="Subject"
        >
          {getFieldDecorator('subject', {
            rules: [{
              required: !R.isEmpty(selectedContacts) && true, message: 'Please input Subject',
            }],
            initialValue: subject,
          })(<InputS
            placeholder="Enter Subject"
            size="large"
            disabled={R.isEmpty(selectedContacts)}
          />)}
        </FormItemS>
        <FormItemS
          colon={false}
          label="Description"
        >
          {getFieldDecorator('description', {
            initialValue: description,
          })(<ReactQuillWrapped
            height="220px"
            withPaddings
            bounds="#description"
            theme="snow"
            scrollingContainer="#description"
            placeholder="Enter description here..."
          />)}
        </FormItemS>
        <DividerS />
        <FormItemS
          colon={false}
          label="When?"
        >
          {getFieldDecorator('requestDate', {
            rules: [{
              required: !R.isEmpty(selectedContacts) && true, message: 'Please select Date',
            }],
            initialValue: date,
          })(<DatePickerS
            disabled={R.isEmpty(selectedContacts)}
            disabledDate={disabledFutureDays}
          />)}
        </FormItemS>
        <Controls>
          <DetailItem>
            <DetailKey>Status:</DetailKey>
            <Popconfirm
              title="Are you sure you want to change the status to Won?"
              onConfirm={onConfirmStatusChange}
              onCancel={onCancelStatusChange}
              visible={isStatusPopUpVisible}
              placement="topLeft"
            >
              <DetailValue data-popconfirm-stay-open>
                <StyledSelect
                  options={requestStatusesOptions}
                  value={selectedRequestStatus}
                  color={selectedRequestStatus.color}
                  onChange={handleChangeStatus}
                  isSearchable={false}
                  name="status"
                  isDisabled={R.isEmpty(selectedContacts)}
                  form
                />
              </DetailValue>
            </Popconfirm>
          </DetailItem>
          <DetailItem>
            <DetailKey>Source:</DetailKey>
            <DetailValue>
              <StyledSelect
                options={requestSourcesOptions}
                value={selectedRequestSource}
                color={selectedRequestSource.color}
                onChange={setSelectedRequestSource}
                isSearchable={false}
                name="source"
                isDisabled={R.isEmpty(selectedContacts)}
                form
              />
            </DetailValue>
          </DetailItem>
          <DetailItem>
            <DetailKey>Labels:</DetailKey>
            <DetailValue>
              <StyledSelect
                form
                isMulti
                name="label"
                isClearable={false}
                value={selectedRequestLabels}
                onChange={handleChangeLabels}
                options={requestLabelsOptions}
                isDisabled={R.isEmpty(selectedContacts)}
              />
            </DetailValue>
          </DetailItem>
        </Controls>
        <DividerS />
        <FieldWrapper>
          <AssignButton
            type="button"
            disabled={selectedUsers.includes(getCurrentUserId())}
            onClick={() => {
              setSelectedUsers([...selectedUsers, getCurrentUserId()]);
              setFieldsValue({ assignees: [...selectedUsers, getCurrentUserId()] });
            }}
          >
            <SvgIcon type="plus" /> Assign me
          </AssignButton>
          <FormItemS
            colon={false}
            label="Assignees"
          >
            <SelectS
              mode="multiple"
              showSearch
              size="large"
              allowClear
              value={selectedUsers}
              placeholder="Choose assignees..."
              defaultActiveFirstOption={false}
              getPopupContainer={triggerNode => triggerNode.parentNode}
              onChange={(value) => {
                const unassignedSales = checkUnassignedSalesWithoutTasks({
                  value, selectedUsers, requestTasks, tasks, users,
                });
                if (unassignedSales) {
                  confirm({
                    title: `${unassignedSales} will lose access to this request when unassigned, continue?`,
                    okText: 'Yes',
                    okType: 'danger',
                    cancelText: 'No',
                    centered: true,
                    onOk() {
                      setSelectedUsers(value);
                    },
                  });
                } else {
                  setSelectedUsers(value);
                }
              }}
              filterOption={(input, option) =>
                option.props.children.props.children[1]
                  .toLowerCase().indexOf(input.toLowerCase().trim()) >= 0
              }
            >
              { sortDataByAlphabet('fullName', Object.values(users)).map(user => (
                <Option
                  key={user._id}
                  value={user._id}
                  hidden={!user.isActivated}
                >
                  <OptionWrapper>
                    <UserImageWrap
                      width={24}
                      height={24}
                      src={getAvatarUrl(user.profileImage)}
                    />
                    {user.fullName} <Divider type="vertical" /> {user.email}
                  </OptionWrapper>
                </Option>
              ))}
            </SelectS>
          </FormItemS>
        </FieldWrapper>

        <Attachments
          {...{
            ...props,
            isLoading: isAttachmentsLoading,
          }}
          wrapperStyles={{ padding: 'unset', borderTop: 'unset' }}
          inModal
        />

        <DividerS />
        <ButtonWrapper>
          <ButtonSave
            key="submit"
            type="primary"
            htmlType="submit"
            disabled={isContactFormOpen}
            loading={isLoading || isAttachmentsLoading}
          >
            Save
          </ButtonSave>
        </ButtonWrapper>
      </Form>
    </Fragment>
  );
};

RequestForm.propTypes = {
  setSelectedRequestSource: func.isRequired,
  selectedRequestSource: object.isRequired,
  selectedRequestStatus: object.isRequired,
  requestStatusesOptions: array.isRequired,
  selectedRequestLabels: array.isRequired,
  requestSourcesOptions: array.isRequired,
  requestLabelsOptions: array.isRequired,
  onConfirmStatusChange: func.isRequired,
  isStatusPopUpVisible: bool.isRequired,
  onCancelStatusChange: func.isRequired,
  handleContactSearch: func.isRequired,
  setSelectedContacts: func.isRequired,
  setSelectedProject: func.isRequired,
  isFetchingContacts: bool.isRequired,
  handleChangeStatus: func.isRequired,
  handleChangeLabels: func.isRequired,
  searchedContacts: array.isRequired,
  setSelectedUsers: func.isRequired,
  onSubmitForm: func.isRequired,
  attachments: array.isRequired,
  onToggleContactForm: func,
  setContactsData: func.isRequired,
  title: string.isRequired,
  form: object.isRequired,
  selectedContacts: array,
  isEdit: bool.isRequired,
  isContactFormOpen: bool,
  selectedUsers: array,
  selectedProject: string,
  projects: array,
  withAddContact: bool,
  description: string,
  isLoading: bool,
  isAttachmentsLoading: bool,
  subject: string,
  users: object,
  date: object,
  requestTasks: array.isRequired,
  tasks: object.isRequired,
  isFetchingProjects: bool,
};

RequestForm.defaultProps = {
  onToggleContactForm: undefined,
  isContactFormOpen: undefined,
  selectedContacts: undefined,
  selectedProject: undefined,
  projects: [],
  selectedUsers: undefined,
  withAddContact: false,
  isAttachmentsLoading: false,
  isFetchingProjects: false,
  isLoading: false,
  description: '',
  subject: '',
  date: null,
  users: {},
};

export default RequestForm;



// WEBPACK FOOTER //
// ./src/components/request-form/index.js